import { Stack, Typography } from '@mui/material';
import _ from 'lodash';
import React from 'react';
import { Task } from '../../../../types/Task';
import { humanizeTimestamp } from '../../../../utility/dateUtils';
import TaskStatusPill from '../../../tasks/TaskStatusPill';
import InfoRow from './InfoRow';

const TaskDrawerCard: React.FC<{ task: Task }> = ({ task }) => (
  <Stack spacing={0.5} sx={{ borderBottom: '1px solid #eee', py: 1 }}>
    <Stack direction="row" justifyContent="space-between" spacing={0.5}>
      <Typography
        variant="body2"
        noWrap
        title={task.name}
        sx={{ fontWeight: 600 }}
      >
        {task.name}
      </Typography>
      <TaskStatusPill status={task.status} />
    </Stack>

    <InfoRow label="Start" value={humanizeTimestamp(task.start_date)} />
    <InfoRow label="Due" value={humanizeTimestamp(task.due_date)} />
    <InfoRow label="Employee" value={task.employee_display_name} />
  </Stack>
);

type Props = { tasks: Task[] };

const TaskDrawerList: React.FC<Props> = ({ tasks }) => {
  if (_.isEmpty(tasks)) {
    return (
      <Typography variant="body2" color="text.secondary">
        No tasks found
      </Typography>
    );
  }

  return (
    <>
      {_.map(tasks, (task) => (
        <TaskDrawerCard key={task.uuid} task={task} />
      ))}
    </>
  );
};

export default TaskDrawerList;
